import JoinDetailsAction from '../../actions/joinDetails';
import ValidationRunner from './runner';
import {
    notEmpty, lengthAtLeast, lengthAtMost,
    numberAtLeast, numberAtMost, isWholeNumber, isValidPropertyName,
    isValidUnicodePropertyName
} from './joinRules';
import { fireValidationAction, genericFireAction } from './util';
import * as ValdiationRules from './rules';

export default (store) => (next) => (action) => {
    // Guard against null/undefined actions or non-action objects (like Promises)
    if (!action || typeof action !== 'object' || !action.type) {
        return next(action);
    }

    let result;
    let resultAction;
    let latinNameCheckResult;

    switch (action.type) {
    case JoinDetailsAction.SET_WEBSITE_URL:
        resultAction = JoinDetailsAction.setWebsiteUrlValidation;
        result = action.websiteUrl
            ? ValidationRunner(
                action.websiteUrl,
                [
                    ValdiationRules.lengthAtLeast(5),
                    ValdiationRules.lengthAtMost(255),
                    ValdiationRules.isValidWebsite
                ]
            )
            : { isValid: true };
        break;
    case JoinDetailsAction.SET_PROPERTY_NAME:
        resultAction = JoinDetailsAction.setPropertyNameValidation;
        result = ValidationRunner(
            action.propertyName,
            [notEmpty('propertyName.requiredError'), lengthAtLeast(4, 'propertyName.lengthError'), lengthAtMost(40, 'propertyName.lengthError'), isValidUnicodePropertyName]
        );
        latinNameCheckResult = ValidationRunner(action.propertyName, [isValidPropertyName]);
        if (latinNameCheckResult.isValid) {
            genericFireAction(store, JoinDetailsAction.setLatinPropertyName, '');
        }
        break;
    case JoinDetailsAction.SET_LATIN_PROPERTY_NAME:
        resultAction = JoinDetailsAction.setLatinPropertyNameValidation;
        result = ValidationRunner(
            action.latinPropertyName,
            [notEmpty('propertyName.requiredError'), lengthAtLeast(4, 'propertyName.lengthError'), lengthAtMost(40, 'propertyName.lengthError'), isValidPropertyName]
        );
        break;
    case JoinDetailsAction.SET_PROPERTY_TYPE:
        resultAction = JoinDetailsAction.setPropertyTypeValidation;
        result = ValidationRunner(action.propertyType, [notEmpty('propertyType.requiredError')]);
        break;
    case JoinDetailsAction.SET_UNIT_COUNT:
        resultAction = JoinDetailsAction.setUnitCountValidation;
        result = ValidationRunner(
            action.unitCount,
            [notEmpty('unitCount.errorMessage.required'),
                isWholeNumber('unitCount.errorMessage.length'),
                numberAtLeast(1, 'unitCount.errorMessage.length'),
                numberAtMost(9999, 'unitCount.errorMessage.length')]
        );
        break;
    case JoinDetailsAction.SET_CURRENCY_CODE:
        resultAction = JoinDetailsAction.setCurrencyValidation;
        result = ValidationRunner(action.currency, [notEmpty('currency.errorMessage.required')]);
        break;
    default:
        break;
    }
    if (result && resultAction) {
        fireValidationAction(result, store, resultAction);
    }

    return next(action);
};
